// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"b8ad1660480c2fc43226","240":"2bbe3e1cdb8c40b42a82"}[chunkId] + ".js";
};